import styled from 'styled-components';

export const ToolTipText = styled('span')`
  display: inline-block;
  max-width: 200px;
`;
